import { useState } from "react";
import _ from "lodash";
import { FormControl, TextField, InputAdornment } from "@mui/material/";
import { searchAssets } from "../../../utils/API/Assets/Assets";
import { useHistory } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import SearchIcon from "@mui/icons-material/Search";

export default function AssetSelector(props) {
  const {
    apiUrl,
    assetMode = "AllAssets",
    onAssetClick,
    onError = () => { },
    organizationId,
    size = "small",
    token,
  } = props;
  const [options, setOptions] = useState([]);
  const history = useHistory();

  const debounce_try = _.debounce((inputValue) => {
    searchAssets(
      { apiUrl, token, organizationId },
      { filters: { assetMode, tag: inputValue, limit: 300 } }
    ).then((results) => {
      if (results.error) {
        onError(results.error);
      }
      const options =
        results.assets.map((asset) => {
          return {
            label: asset.tag,
            value: asset.assetId,
          };
        }) || [];

      setOptions(options);
    });
  }, 1000);

  function onChange(event) {
    const { value = "" } = event || {};

    if(onAssetClick) {
      console.log(event)
    } else {
      history.push(`/assetSnapshot/${value}`);
    }
  }

  return (
    <FormControl sx={{ width: "100%", maxWidth: "500px" }} variant="filled">
      {/* https://mui.com/material-ui/react-autocomplete/#search-as-you-type */}
      <Autocomplete
        autoComplete
        disableCloseOnSelect
        filterOptions={(x) => x}
        filterSelectedOptions
        fullWidth
        getOptionLabel={(option) => option?.label}
        id="inventory-ea-txtselect-binlocation"
        includeInputInList
        multiple={false}
        noOptionsText="Start typing to search assets"
        onChange={(event, value) => onChange(value)}
        onClose={() => setOptions([])}
        onInputChange={(event, newInputValue) => {
          if (
            newInputValue !== "undefined" &&
            newInputValue?.trim().length !== 0
          ) {
            debounce_try(newInputValue);
          }
        }}
        options={options}
        renderInput={(params) => (
          <TextField 
            fullWidth 
            placeholder="Search for an asset..." 
            {...params}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "#64748b", fontSize: "1.25rem", ml: 0.5 }} />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "#f8fafc",
                borderRadius: "25px",
                paddingLeft: "8px",
                height: "44px",
                transition: "all 0.2s ease-in-out",
                border: "1px solid #e2e8f0",
                "&:hover": {
                  backgroundColor: "#f1f5f9",
                  borderColor: "#A0C46D",
                },
                "&.Mui-focused": {
                  backgroundColor: "#ffffff",
                  borderColor: "#A0C46D",
                  boxShadow: "0 0 0 3px rgba(160, 196, 109, 0.15)",
                },
              },
              "& .MuiOutlinedInput-input": {
                padding: "10px 8px",
                fontSize: "0.9rem",
                color: "#1e293b",
                "&::placeholder": {
                  color: "#64748b",
                  opacity: 1,
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "& .MuiInputLabel-root": {
                display: "none",
              },
            }}
          />
        )}
        size={size}
        sx={{
          "& .MuiAutocomplete-popupIndicator": {
            color: "#64748b",
            marginRight: "4px",
            "&:hover": {
              backgroundColor: "rgba(160, 196, 109, 0.1)",
            },
          },
          "& .MuiAutocomplete-clearIndicator": {
            color: "#64748b",
            "&:hover": {
              backgroundColor: "rgba(160, 196, 109, 0.1)",
            },
          },
        }}
        PaperComponent={({ children, ...props }) => (
          <div
            {...props}
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 10px 40px rgba(0, 0, 0, 0.12)",
              border: "1px solid #e2e8f0",
              marginTop: "8px",
              overflow: "hidden",
            }}
          >
            {children}
          </div>
        )}
        componentsProps={{
          paper: {
            sx: {
              "& .MuiAutocomplete-option": {
                padding: "12px 16px",
                fontSize: "0.875rem",
                color: "#1e293b",
                transition: "all 0.15s ease-in-out",
                "&:hover": {
                  backgroundColor: "rgba(160, 196, 109, 0.1)",
                },
                "&[aria-selected='true']": {
                  backgroundColor: "rgba(160, 196, 109, 0.15)",
                },
              },
              "& .MuiAutocomplete-noOptions": {
                padding: "16px",
                fontSize: "0.875rem",
                color: "#64748b",
              },
            },
          },
        }}
      />
    </FormControl>
  );
}
